import { twMerge } from '@belong/common';
import { Image, Text } from '@belong/ui';

type Props = {
  description: string;
  descriptionClassname?: string;
  src: string;
  title: string;
};

export const DepositFAQSItem = ({
  description,
  descriptionClassname,
  src,
  title,
}: Props) => (
  <div className="flex flex-col items-center justify-around sm:flex-row">
    <Image
      alt={title}
      className="h-[230px] w-[400px] object-contain"
      src={src}
    />
    <div className="mr-0 w-full pt-xs sm:mr-xs sm:w-auto sm:pt-0">
      <Text className={twMerge('max-w-[375px]', descriptionClassname)}>
        {description}
      </Text>
    </div>
  </div>
);
